export const eur = (n, opts = {}) =>
  new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR", maximumFractionDigits: 0, ...opts }).format(n || 0);

export const eurExact = (n) => eur(n, { maximumFractionDigits: 2, minimumFractionDigits: 2 });

// "2026-10" -> "October 2026"
export const monthLabel = (ym, style = "long") => {
  if (!ym) return "";
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-IE", { month: style, year: style === "long" ? "numeric" : "2-digit" });
};

// "2026-10-02" -> "2 Oct"
export const shortDate = (iso) => {
  if (!iso || iso.startsWith("0000")) return "";
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-IE", { day: "numeric", month: "short" });
};

export const pctChange = (current, previous) => {
  if (!previous) return null;
  return Math.round(((current - previous) / previous) * 100);
};
